<script setup>
// VUE 3 version of VUE 2 'modules/custom/common/vue/js/skeleton-loader.js' (Library: 'vue/skeletonLoader')
import { ref, computed } from 'vue';

//props
const { maxWidth, minWidth, height, marginTop, width, borderRadius } = defineProps({
  maxWidth: {
    // The default maxiumum width is 100%.
    default: 100,
    type: Number,
  },
  minWidth: {
    // Lines have a minimum width of 80%.
    default: 80,
    type: Number,
  },
  height: {
    // Make lines the same height as text.
    default: '1em',
    type: String,
  },
  marginTop: {
    // Make lines the same height as text.
    default: null,
    type: String,
  },
  width: {
    // Make it possible to define a fixed
    // width instead of using a random one.
    default: null,
    type: String,
  },
  borderRadius: {
    // Make it possible to define a fixed
    // width instead of using a random one.
    default: null,
    type: String,
  },
});

//computed properties
const computedWidth = computed(() => {
  // Either use the given fixed width or
  // a random width between the given min
  // and max values.
  return width || `${Math.floor(Math.random() * (maxWidth - minWidth) + minWidth)}%`;
});
</script>

<template>
  <span class="SkeletonBox" :style="{height, marginTop, borderRadius, width: computedWidth}"></span>
</template>
